module.exports = __webpack_public_path__ + "static/media/info_01.c74ddab0.jpg";